// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__CjWgp","Content":"Sidebar_Content__yOA3F"};